/* ============
 * Admin Groups Actions
 * ============
 *
 * The actions available for the admin-groups module.
 */

import store from '@/store';
import i18n from '@/i18n';
import router from '@/router';
import { adminGroupsApi } from '@/api/AdminGroupsApi';
import * as types from './types';


/**
 * Action fired when all groups will be fetched.
 *
 * @param {function} commit Commit function to update the store.
 * @param {function} fn     Callback to edit the parameters on the api.
 */
const all = ({ commit }, fn = null) => {
  if (typeof fn === 'function') {
    fn(adminGroupsApi);
  }
  store.dispatch('application/startLoading');
  return adminGroupsApi.all()
    .then((response) => {
      store.dispatch('application/finishLoading');
      const data = {
        groups: response.data,
        pagination: response.pagination,
      };
      commit(types.ALL, data);
      return data;
    })
    .catch(() => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: i18n.t('admin.rights.groups.messages.all.error'),
      });
      commit(types.NONE);
    });
};

/**
 * Action fired when a group will be created.
 *
 * @param {function} commit  Commit function to update the store.
 * @param {Object}   group   The group that will be created.
 */
const create = ({ commit }, group) => {
  store.dispatch('application/startLoading');
  adminGroupsApi.create(group)
    .then(() => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: `<span data-id="${group.id}">${i18n.t('admin.rights.groups.messages.create.success')}</span>`,
      });

      router.push({
        name: 'admin.rights.groups.index',
      });
    })
    .catch(() => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: i18n.t('admin.rights.groups.messages.create.error'),
      });
    });
};

/**
 * Action fired when an group will be updated.
 *
 * @param {function} commit  Commit function to update the store.
 * @param {Object}   group   The group that will be updated.
 */
const update = ({ commit }, group) => {
  store.dispatch('application/startLoading');
  adminGroupsApi.update(group.id, { name: group.name, users: group.users })
    .then(() => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: `<span data-id="${group.id}">${i18n.t('admin.rights.groups.messages.update.success')}</span>`,
      });
    })
    .catch(() => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: i18n.t('admin.rights.groups.messages.update.error'),
      });
    });
};

/**
 * Action fired when an group will be destroyed.
 *
 * @param {function} commit    Commit function to update the store.
 * @param {Object}   groupId   The group that will be destroyed.
 */
const destroy = ({ commit }, groupId) => {
  store.dispatch('application/startLoading');
  adminGroupsApi.destroy(groupId)
    .then(() => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: i18n.t('admin.rights.groups.messages.destroy.success'),
      });

      router.push({
        name: 'admin.rights.groups.index',
      });
    })
    .catch(() => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: i18n.t('admin.rights.groups.messages.destroy.error'),
      });
    });
};


export default {
  all,
  create,
  update,
  destroy,
};



// WEBPACK FOOTER //
// ./src/store/modules/admin-groups/actions.js